import { isNonEmptyArray } from '@/utils/checks'
import { Location } from '../../../types/models/Location.model'

interface GetSortedBreadcrumbsFromLocation {
  (props: {
    location: Location
    locationTitleToSkip?: string
  }): Location['title'][]
}

const getSortedBreadcrumbsFromLocation: GetSortedBreadcrumbsFromLocation = ({
  location,
  locationTitleToSkip
}) => {
  if (isNonEmptyArray(location?.address_parts)) {
    return location.address_parts
      .filter((part) => part && part.title !== locationTitleToSkip)
      .reverse()
      .map((part) => part.title)
  }
  return []
}

export default getSortedBreadcrumbsFromLocation
